/**
 * Manages AbortController for refresh token requests.
 * Allows aborting pending refresh requests during session changes (impersonation start/stop).
 */
class RefreshTokenAbortManager {
  private controller: AbortController;

  constructor() {
    this.controller = new AbortController();
  }

  /** Get the current abort signal */
  get signal(): AbortSignal {
    return this.controller.signal;
  }

  /** Abort current request and create fresh controller for future requests */
  abort(): void {
    this.controller.abort();
    this.controller = new AbortController();
  }
}

const RefreshTokenAbortController = new RefreshTokenAbortManager();

export { RefreshTokenAbortController };
